//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {
		api_CaseDetail
	} from '@/api'
	//箱子信息
	export default {
		name: 'open',
		data() {
			return {
				Height: 0,
				drop_svga:'',
				model_svga:'',
				start_svga:'',



				box_data: {
					caseInfo:{ 
						caseName:'',
						price:0
					},
					items:null,
				}, //箱子信息
				init: [], //svga及模型加载
				prize_item: {}, //奖品
				open_status: 0, //开箱状态  0:未开  1:开启中  2:结束(饰品展示)
				animation_status: 0, //模型及svga状态  0:svga掉落  1:模型  2:箱子开启svga
				start_vague: false, //svga开启结束模糊类名
				result_show: false, //结果展示
				suspend_status: false, //开箱后终止
				iSgold:true,//是否有'金'
				rootGold:false,//底部操作栏(金相关)
			}
		},
		created() {
			this.getBoxData()
			this.set_official_loading(true)
		},
		mounted() {
			this.Height = document.documentElement.clientHeight || document.body.clientHeight
			this.$nextTick(() => {
				document.addEventListener('keyup', this.stop_open)
			})
		},
		methods: {
			//箱子信息
			getBoxData() {
				api_CaseDetail(this.$route.query.id).then(res => {
					if (res.data.code === 0) {
						this.box_data = res.data.data;

						this.drop_svga = require('@/assets/svga/drop.svg')
						this.model_svga = require('@/assets/svga/model.svg')
						this.start_svga = require('@/assets/svga/open.svg')

					} else {
						this.set_official_loading(false)
					}
				}).catch(err => {
					this.set_official_loading(false)
					this.$message({
						message: '加载失败,请刷新重试',
						type: 'success'
					})
				})
			},
			
			//本箱子是否有"金"
			togolden(gold){
				this.iSgold = gold
			},
			
			
			//svga及模型加载
			initial() {

				this.init.push('yes')
				if (this.init.length == 3) {
					this.set_official_loading(false)
					//全部完成后播放掉落动画
					setTimeout(() => {
						this.$refs.boxfall.start()
					}, 300)
				}
			},

			// svga掉落动画结束
			fall_finish() {
				//切换模型显示
				setTimeout(() => {
					this.animation_status = 1
				}, 300)
			},
			
			
			//开箱成功
			open_success(item) {
				//先让模型位置复原(衔接箱子打开svga动画)
				this.$refs.boxmodel.homing(item)
			},

			//模型位置复原
			returned(item) {
				//终止开箱状态复原
				this.suspend_status = false
				//奖品赋值
				this.prize_item = item
				//切换底部操作栏状态
				this.open_status = 1
				//切换svga下坠动画&&隐藏箱子饰品和右侧掉落
				this.animation_status = 2
				//svga下坠动画播放
				this.$refs.boxstart.start()
			},

			/*正常情况开箱*/
			//svga开启动画结束
			start_finish() {
				//如果没有终止开箱
				if (!this.suspend_status) {
					//svga开启动画模糊
					this.start_vague = true
					//滚动第一步
					this.$refs.conduct.step(this.prize_item)
				}
			},

			//动画结束
			move_end() {
				//切换底部操作栏状态
				this.open_status = 2
				//所以svga动画&&箱子饰品和右侧掉落 => 全部隐藏
				this.animation_status = 4
				//svga开启动画模糊
				this.start_vague = true
				//结果展示
				this.result_show = true
				this.$refs.result.show(this.prize_item)
			},
			
			
			//改变金状态(底部)
			setGold(){
				this.rootGold = true
			},
			
			
			//底部操作栏
			//关闭奖品展示
			to_stock() {
				//切换底部操作栏状态
				this.open_status = 0
				//展示模型&&展示下方箱内饰品&&展示掉落
				this.animation_status = 1
				//svga开启动画关闭模糊
				this.start_vague = false
				//结果隐藏
				this.result_show = false
				this.$refs.result.close()
				this.rootGold = false
			},

			/*开箱后终止开箱*/
			
			//esc事件
			stop_open(e){
				//esc
				if(e.keyCode == 27){
					//如果正在开箱
					if(this.open_status === 1){
						this.$refs.operation.suspend()
					}
				}
			},
			
			
			//终止开箱
			suspend() {
				this.suspend_status = true
				//切换底部操作栏状态
				this.open_status = 0
				//展示模型&&展示下方箱内饰品&&展示掉落
				this.animation_status = 1
				//svga开启动画关闭模糊
				this.start_vague = false
				//结果隐藏
				this.result_show = false
				this.$refs.result.close()
				this.$refs.conduct.reset()
			},
			
		},
		
		//销毁页面移出keyup事件
		beforeDestroy() {
			document.removeEventListener('keyup', this.stop_open)
		},
		
		components: {
			sidebar: () => import('./components/sidebar/index.vue'), //右侧历史掉落
			contain: () => import('./components/contain/index.vue'), //下方箱子饰品
			operation: () => import('./components/operation/index.vue'), //底部操作区域

			boxmodel: () => import('./components/boxmodel/index.vue'), //箱子模型
			boxfall: () => import('./components/boxfall/index.vue'), //箱子下坠svga
			boxstart: () => import('./components/boxstart/index.vue'), //箱子打开svga

			conduct: () => import('./components/conduct/index.vue'), //开箱滚动
			result: () => import('./components/result/index.vue'), //结果展示
		}
	}
